// SPDX-FileCopyrightText: 2026 Ebiose AI
// SPDX-License-Identifier: LicenseRef-Ebiose-Proprietary
// All rights reserved. Confidential — unauthorized distribution prohibited.

import { useState } from "react"
import { formatCycleId } from "@/lib/cycle-id"

// PRD US §2/§3 (short+full display), US §12 (copy is read-only — not a cycle mutation).
export interface CycleIdCellProps {
  id: string
}

export const CycleIdCell = ({ id }: CycleIdCellProps) => {
  const { short, full } = formatCycleId(id)
  const [copied, setCopied] = useState(false)

  const copy = async (e: React.MouseEvent) => {
    // Don't let the copy click bubble to the row's onClick (navigation).
    e.stopPropagation()
    try {
      await navigator.clipboard?.writeText(full)
      setCopied(true)
      window.setTimeout(() => setCopied(false), 1200)
    } catch {
      // Clipboard unavailable (e.g. insecure context) — the full id is
      // still exposed via the title tooltip, so this degrades gracefully.
    }
  }

  return (
    <button
      type="button"
      title={full}
      aria-label={`Copy full cycle id ${full}`}
      onClick={copy}
      className="font-mono select-text text-xs hover:underline"
    >
      {short}
      {copied && (
        <span className="ml-1 text-[10px] text-text-tertiary">copied</span>
      )}
    </button>
  )
}
